export type TutorialRewards = typeof rewards;
export type TutorialStep = keyof TutorialRewards;

export const rewards = {
  basicGameplay: 100,
  chatWithPets: 100,
  careForPets: 100,
  friendReferral: 100, // *NOTE: Currently overridden to 0 when in-game friends feature flag is enabled
  profile: 100, // *NOTE: Currently overridden to 0 when in-game friends feature flag is enabled
  match3: 100,
  visitFriend: 100,
  adult: 100,
  duoInvite: 100,
  duoInviteReceived: 100,
  decoration: 100,
  daycare: 100,
  decorationBonus: 100,
  catalog: 100,
  accessory: 100,
  encyclopedia: 100,
  growthCapsule: 100,
  slots: 100,
  bubbleSlot: 100,
  throwBuruBuru: 100,
  match2: 100,
  decorationProgression: 100,
  bumbum: 100,
  transform: 100,
  petCollection: 100,
  costumeBoost: 100,
  teams: 100,
  friendship: 100,
  makeHappy: 0,
  addFriends: 0,

  puzzleCoinsBasic: 0,
  puzzleCoinsCare: 0,
};

export const TutorialSteps = Object.keys(rewards) as TutorialStep[];
export const version = '1.1.0';
